import { Link, navigate } from "gatsby"
import React, { useContext, useState, useEffect } from "react"
import { Row, Col } from "react-bootstrap"

import FallBackImage from "../../images/wdn-avatar-placeholder.png"
import Tick from "../../images/check.png"
import TickPlus from "../../images/tick-with-plus.png"

import CheckBox from "../input/checkbox"
import { GlobalAuthContext } from "../../context/authContext"

import {
  CANDIDATE_ADD_TO_CART,
  CANDIDATE_CART_DELETE,
  CANDIDATE_SHORTLIST,
  CANDIDATE_SHORTLIST_DELETE,
  CANDIDATE_PAID_CV_DELETE,
} from "../company-profile/statistics/action/statisticsAction"
import checkIdExistsInSearch from "../../utils/check-id-exists-in-search"

import "./candidate-card.scss"
import CardButton from "./card-button"
import { formatSalaryWithComma } from "../../utils/formatSalary"
import endpoints from "../../constants/endpoints"

const CandidateCard = ({
  candidate,
  loading,
  setLoading,
  selected,
  setList,
  shortlist,
  cart,
  page,
  displayViewProfileButton,
  displayShortlistButton,
  displayCartButton,
  displayCartDeleteButton,
  displayShortlistDeleteButton,
  displayPaidCvsDeleteButton,
  setRefresh,
  refresh,
  isFromJobVisible,
  isApplicant,
}) => {
  const [isInCart, setInCart] = useState(false)
  const [isShortlisted, setShortlist] = useState(false)
  const [cartItems, setCart] = useState(cart)
  const [shortlistItems, setShortlistItems] = useState(shortlist)

  const { state, dispatch } = useContext(GlobalAuthContext)

  const handleCartDelete = () => {
    setLoading(true)
    dispatch({
      type: "MODAL",
      payload: {
        showModal: 1,
        deleteId: candidate?.item_id,
        deleteItem: deleteCartItem,
      },
    })
  }

  const handlePaidCvsDelete = () => {
    setLoading(true)
    dispatch({
      type: "MODAL",
      payload: {
        showModal: 1,
        deleteId: candidate?.item_id,
        deleteItem: deletePaidCv,
      },
    })
  }

  const deleteCartItem = (modal, deleteId) => {
    CANDIDATE_CART_DELETE(
      deleteId,
      setLoading,
      state,
      dispatch,
      modal,
      setRefresh,
      refresh
    )
  }

  const deletePaidCv = (modal, deleteId) => {
    CANDIDATE_PAID_CV_DELETE(deleteId, setLoading, state, dispatch, modal)
  }

  const handleShortlistDelete = () => {
    setLoading(true)
    dispatch({
      type: "MODAL",
      payload: {
        showModal: 1,
        deleteId: candidate?.item_id,
        deleteItem: deleteShortlistedItem,
      },
    })
  }

  const deleteShortlistedItem = (modal, deleteId) => {
    CANDIDATE_SHORTLIST_DELETE(
      deleteId,
      setLoading,
      state,
      dispatch,
      modal,
      setRefresh,
      refresh
    )
  }

  const handleShortlist = () => {
    if (state?.isAuthenticated && state?.user && state?.user?.role === 3) {
      try {
        setLoading(true)
        const user = JSON.parse(localStorage.getItem("user"))
        let data = {}
        if (isApplicant) {
          data = {
            url: `${endpoints?.JOB_POSTING_BASE}${endpoints?.JOB_APPLICANT_SHORTLIST}`,
            data: {
              application_id: candidate?.applicant_id,
            },
            shortlistedData: candidate,
          }
        }
        CANDIDATE_SHORTLIST(
          state?.user?.company?.id ?? user?.company?.id,
          candidate?.candidate?.id ?? candidate?.id,
          setLoading,
          setShortlist,
          setShortlistItems,
          shortlistItems,
          state,
          dispatch,
          data
        )
      } catch (err) {
        console.log(err)
      }
    } else if (!state?.isAuthenticated) {
      navigate("/login")
    } else if (!state?.isEmailVerified && state?.isAuthenticated) {
      navigate("/verify-email")
    }
  }

  const handleAddToCart = () => {
    if (state?.isAuthenticated && state?.user && state?.user?.role === 3) {
      try {
        setLoading(true)
        const user = JSON.parse(localStorage.getItem("user"))
        CANDIDATE_ADD_TO_CART(
          user?.company?.id,
          candidate?.candidate?.id,
          setLoading,
          setInCart,
          setCart,
          cartItems,
          state,
          dispatch
        )
      } catch (err) {}
    } else if (!state?.isAuthenticated) {
      navigate("/login")
    } else if (!state?.isEmailVerified && state?.isAuthenticated) {
      navigate("/login")
    } else if (!state?.isEmailVerified && state?.isAuthenticated) {
      navigate("/verify-email")
    }
  }

  const handleCheckBoxChange = value => {
    setList(value)
  }

  useEffect(() => {
    setShortlistItems(shortlist)
    setCart(cart)
    if (checkIdExistsInSearch(state?.cart, candidate?.candidate?.id) > 0) {
      setInCart(true)
    }

    if (
      checkIdExistsInSearch(
        state?.shortlist,
        candidate?.candidate?.candidate_id ?? candidate?.candidate?.id
      ) > 0
    ) {
      setShortlist(true)
    }
  }, [state.cart, state.shortlist]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="candidate-card text-md-center position-relative">
      {isFromJobVisible && candidate?.is_applicant ? (
        <Link
          to={`/jobs/${candidate?.job?.id}`}
          className="is-applicant text-white"
        >
          From job: {candidate?.job?.title}
        </Link>
      ) : (
        <></>
      )}
      <Row className="align-items-center pt-2 pb-2">
        <Col md="8" xs="12">
          <Row className="align-items-center">
            <Col md={1} xs={12} className="text-left">
              {candidate?.profile?.experience !== "Fresher" &&
                state?.isAuthenticated &&
                candidate?.profile?.experience &&
                page === "search" && (
                  <CheckBox
                    onChange={handleCheckBoxChange}
                    value={candidate?.candidate?.id}
                    checked={selected}
                  />
                )}
            </Col>
            <Col
              md={state?.isAuthenticated && page === "search" ? 11 : 11}
              xs={12}
            >
              <Link
                to={`/candidate/detail/${candidate?.username}`}
                data-toggle="tooltip"
                title={
                  candidate?.profile?.status
                    ? Number(candidate?.profile?.status) === 1
                      ? "Available"
                      : "Open For Offers"
                    : ""
                }
              >
                <div className="candidate-info">
                  <Row className="align-items-center text-center text-md-left">
                    <Col md="4" sm="12" className="mb-lg-0 mb-4 no-padding">
                      <div className="candidate-image search-image">
                        <img
                          src={
                            candidate?.candidate?.thumbnail
                              ? candidate?.candidate?.thumbnail
                              : candidate?.avatar
                              ? candidate?.avatar
                              : FallBackImage
                          }
                          alt={
                            candidate?.first_name +
                            "-" +
                            candidate?.last_name +
                            "- avatar"
                          }
                        />
                      </div>
                    </Col>
                    <Col md="8" sm="12" className="mb-lg-0 mb-4 no-padding">
                      <div className="candidate-text pl-2">
                        <h3 className="mb-0">
                          {candidate?.first_name + " " + candidate?.last_name}
                          <span className="tick-image">
                            {Number(candidate?.profile?.status) === 1 && (
                              <img src={Tick} alt="" />
                            )}
                            {Number(candidate?.profile?.status) === 2 && (
                              <img src={TickPlus} alt="" />
                            )}
                          </span>
                        </h3>
                        {candidate?.profile?.position && (
                          <p> {candidate?.profile?.position}</p>
                        )}
                        {candidate?.candidate?.current_address && (
                          <p>{candidate?.candidate?.current_address}</p>
                        )}
                        {candidate?.profile?.experience && (
                          <p>
                            Experience:{" "}
                            <span className="bold">
                              {candidate?.profile?.experience}
                            </span>
                          </p>
                        )}
                        {candidate?.profile?.expected_salary && (
                          <p>
                            Expected Salary(/m):{" "}
                            <span className="bold">
                              {(state?.isAuthenticated
                                ? candidate?.profile?.currency ?? "NPR"
                                : "") +
                                formatSalaryWithComma(
                                  candidate?.profile?.expected_salary
                                )}
                            </span>
                          </p>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
          </Row>
        </Col>
        <Col md="4" xs="12">
          <Row className="text-lg-right text-center">
            {state?.isAuthenticated && candidate?.profile?.price ? (
              <Col lg="12">
                <p className="mb-2">
                  CV Amount:{" "}
                  <span className="blue-text bold">
                    {candidate?.profile?.currency +
                      ". " +
                      formatSalaryWithComma(candidate?.profile?.price)}
                  </span>
                </p>
              </Col>
            ) : (
              ""
            )}
            <CardButton
              page={page}
              displayPaidCvsDeleteButton={displayPaidCvsDeleteButton}
              handlePaidCvsDelete={handlePaidCvsDelete}
              displayShortlistDeleteButton={displayShortlistDeleteButton}
              displayViewProfileButton={displayViewProfileButton}
              displayCartButtton={displayCartButton}
              displayShortlistButton={displayShortlistButton}
              displayCartDeleteButton={displayCartDeleteButton}
              handleShortlistDelete={handleShortlistDelete}
              handleCartDelete={handleCartDelete}
              candidate={candidate}
              isInCart={isInCart}
              loading={loading}
              state={state}
              isShortlisted={isShortlisted}
              handleAddToCart={handleAddToCart}
              handleShortlist={handleShortlist}
            />
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default CandidateCard
